import React from "react";
import Contact from "../components/Contact";
import { Col, Row, Container } from "reactstrap";
import map from "../assets/images/mappa-tenergia.jpg";
import Section from "./Section";
import Preloader from "../components/Preloader";
import Navbar from '../Layout/Navbar';
import Footer from '../Layout/Footer';
import FooterAlt from '../Layout/FooterAlt';


const Map = () => {
    const mapsLink = "https://www.google.com/maps/place/Via+Isonzo,+251,+04100+Latina+LT/@41.4472633,12.9010084,15.26z/data=!4m5!3m4!1s0x13250c0d48d1be25:0xde6fbcb3a00f2f8!8m2!3d41.447871!4d12.9079176?shorturl=1";

    const goToLink = () =>{
        window.location.href = mapsLink;
    };
  return (
    <>
    
      <Section leftSide="Contattaci"></Section>
      <section className="section background-white" id="services-map">
        <Container>
          <Row className="justify-content-center">
            <Col lg={7}>
              <div className="header-title text-center text-dark">
                <h3 className="fs-1">DOVE SIAMO</h3>
                <div className="title-border mt-3"></div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col sm={12} className="text-center">
              <img src={map} alt="Map" className="img-fluid map-img" onClick={goToLink}/>
            </Col>
          </Row>
          <Row>
           
          </Row>
        </Container>
      </section>
      
    </>
  );
};

const ContactPage = () => {
  return (
    <React.Fragment>
      <Preloader />
      <Navbar />
      <Map />
      <Contact />
      <Footer />
      <FooterAlt />
    </React.Fragment>
  );
};

export default ContactPage;
